import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CasesService } from "../../cases.service";
import * as moment from "moment";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-reminder-dialog",
    templateUrl: "./reminder-dialog.component.html",
    styleUrls: ["./reminder-dialog.component.scss"],
})
export class ReminderDialogComponent implements OnInit {
    reminder_interval: any;
    remark: any;
    labTimeZone: any;
    userName: any;
    hasFirstDataShown: boolean = false;
    constructor(
        public dialogRef: MatDialogRef<ReminderDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public caseService: CasesService,
        public translate: TranslateService
    ) {}

    ngOnInit(): void {
        this.reminder_interval = localStorage.getItem("reminder_interval");
        this.labTimeZone = localStorage.getItem("defaultTz");
        this.userName = localStorage.getItem("name");
    }

    close() {
        this.dialogRef.close();
    }

    markReminderCompleted(reminder: any) {
        this.hasFirstDataShown = true;
        this.caseService
            .updateReminder(reminder.id, {
                status: "Completed",
                remark: this.remark,
                updated_by: this.userName,
                updated_on: moment().tz(this.labTimeZone).valueOf().toString(),
            })
            .subscribe({
                next: (res) => {
                    // console.log("Reminder marked completed: ", res);
                    this.dialogRef.close({ action: "updated" });
                    this.hasFirstDataShown = false;
                },
                error: (err) => {
                    this.hasFirstDataShown = false;
                    console.error("Failed to update reminder", err);
                },
            });
    }

    rescheduleReminder(reminder: any) {
        this.hasFirstDataShown = true;
        let newTime = this.updateNextDueDate(
            this.reminder_interval,
            this.labTimeZone,
            reminder.next_due_date
        );
        // console.log(newTime);
        this.caseService
            .updateReminder(reminder.id, {
                next_due_date: newTime.toString(),
                remark: this.remark,
                updated_by: this.userName,
                updated_on: moment().tz(this.labTimeZone).valueOf().toString(),
            })
            .subscribe({
                next: () => {
                    // console.log("Scheduled Reminder");
                    this.dialogRef.close({ action: "updated" });
                    this.hasFirstDataShown = false;
                },
                error: (err) => {
                    this.hasFirstDataShown = false;
                    console.error("Failed to reschedule reminder", err);
                },
            });
    }

    updateNextDueDate(
        reminder_interval: any,
        labTimezone: string,
        next_due_date: string
    ): number {
        const intervalNumber = Number(reminder_interval);
        const timestamp = Number(next_due_date);

        if (isNaN(intervalNumber) || !labTimezone) {
            console.error("Invalid inputs for updateNextDueDate", {
                reminder_interval,
                labTimezone,
            });
            return NaN;
        }

        let newTime;

        if (this.data?.openWithButton) {
            newTime = moment // moment(timestamp) for adding time in scheduled time
                .tz(labTimezone)
                .add(intervalNumber, "minutes")
                .valueOf();
        } else {
            newTime = moment
                .tz(labTimezone)
                .add(intervalNumber, "minutes")
                .valueOf();
        }

        return newTime;
    }

    closeWithIcon(): void {
        this.dialogRef.close({ action: "close_icon" });
    }
}
